import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-window, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutWindow"><path d="M3 11.5V3H11.5V11.5H3Z" fill="currentColor"/><path d="M3 12.5V21L11.5 21V12.5H3Z" fill="currentColor"/><path d="M12.5 21L21 21V12.5H12.5V21Z" fill="currentColor"/><path d="M21 11.5V3H12.5V11.5H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutWindow;
